/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateReservationsSubscriptionRequest
 */
export interface UpdateReservationsSubscriptionRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateReservationsSubscriptionRequest
     */
    plan: UpdateReservationsSubscriptionRequestPlanEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateReservationsSubscriptionRequest
     */
    paymentFrequency: UpdateReservationsSubscriptionRequestPaymentFrequencyEnum;
}


/**
 * @export
 */
export const UpdateReservationsSubscriptionRequestPlanEnum = {
    Basic: 'basic',
    Core: 'core',
    Premium: 'premium'
} as const;
export type UpdateReservationsSubscriptionRequestPlanEnum = typeof UpdateReservationsSubscriptionRequestPlanEnum[keyof typeof UpdateReservationsSubscriptionRequestPlanEnum];

/**
 * @export
 */
export const UpdateReservationsSubscriptionRequestPaymentFrequencyEnum = {
    Monthly: 'monthly',
    Yearly: 'yearly'
} as const;
export type UpdateReservationsSubscriptionRequestPaymentFrequencyEnum = typeof UpdateReservationsSubscriptionRequestPaymentFrequencyEnum[keyof typeof UpdateReservationsSubscriptionRequestPaymentFrequencyEnum];


/**
 * Check if a given object implements the UpdateReservationsSubscriptionRequest interface.
 */
export function instanceOfUpdateReservationsSubscriptionRequest(value: object): value is UpdateReservationsSubscriptionRequest {
    if (!('plan' in value) || value['plan'] === undefined) return false;
    if (!('paymentFrequency' in value) || value['paymentFrequency'] === undefined) return false;
    return true;
}

export function UpdateReservationsSubscriptionRequestFromJSON(json: any): UpdateReservationsSubscriptionRequest {
    return UpdateReservationsSubscriptionRequestFromJSONTyped(json, false);
}

export function UpdateReservationsSubscriptionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateReservationsSubscriptionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'plan': json['plan'],
        'paymentFrequency': json['paymentFrequency'],
    };
}

export function UpdateReservationsSubscriptionRequestToJSON(json: any): UpdateReservationsSubscriptionRequest {
    return UpdateReservationsSubscriptionRequestToJSONTyped(json, false);
}

export function UpdateReservationsSubscriptionRequestToJSONTyped(value?: UpdateReservationsSubscriptionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'plan': value['plan'],
        'paymentFrequency': value['paymentFrequency'],
    };
}

